var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-overlay"},[(_vm.logoLink)?[_c('div',{staticClass:"logo-image",style:({ backgroundImage: `url(${_vm.logoLink})` })})]:[_c('div',{staticClass:"logo-empty"},[_vm._v(_vm._s(_vm.logoEmptyText))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }